import React from "react";
import Counter from "./components/Counter";
const CounterView = ({
  element
}) => {
  const counterSettings = element?.settings;
  return /*#__PURE__*/React.createElement(Counter, {
    counterSettings: counterSettings
  });
};
export { CounterView };
//# sourceMappingURL=CounterView.js.map